import axios from 'axios';
import GBLVAR from '../GlobalVariable/globalVariable';
import cookie from 'react-cookies';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure({
    position: toast.POSITION.BOTTOM_LEFT,
    autoClose: 3000
});
// const token = localStorage.getItem('token');
const token = cookie.load('token');
class ApiCall {
    get(url, callback) {
        this.createInstance(url, null, 0)
            .then((result) => {
                callback(result.data);
            })
            .catch((error) => {});
    }
    post(url, data, callback) {
        this.createInstance(url, data, 1)
            .then((result) => {
                callback(result.data);
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
    }

    patch(url, data, callback) {
        this.createInstance(url, data, 2)
            .then((result) => {
                callback(result.data);
            })
            .catch((error) => {});
    }

    delete(url, data, callback) {
        this.createInstance(url, data, 3)
            .then((result) => {
                callback(result.data);
            })
            .catch((error) => {});
    }

    createInstance(append, data, type) {
        var instance = axios.create();
        instance.defaults.headers.post['Content-Type'] = 'application/json';
        instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        var url = GBLVAR.BASE_URL + append;
        switch (type) {
            case 0:
                return instance.get(url);
            case 1:
                return instance.post(url, data);
            case 2:
                return instance.patch(url, data);
            default:
                return instance.delete(url, data);
        }
    }
}
export default new ApiCall();
